
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grok-ai-video-generator",
      function () {
        return require("private-next-pages/grok-ai-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grok-ai-video-generator"])
      });
    }
  